var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ImageProcessingSettings" } }, [
    _c("div", { staticClass: "image-processing-settings" }, [
      _c("h2", [
        _vm._v(_vm._s(_vm.$t("chatbotv2.imageProcessingSettings.title"))),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(_vm._s(_vm.$t("chatbotv2.imageProcessingSettings.description"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "processing-mode" }, [
        _c("strong", [
          _vm._v(
            _vm._s(_vm.$t("chatbotv2.imageProcessingSettings.processingMode"))
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-items" },
          [
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: _vm.$t(
                      "chatbotv2.imageProcessingSettings.processWithBlock"
                    ),
                    icon: "ChatAiIcon",
                    description: _vm.$t(
                      "chatbotv2.imageProcessingSettings.processWithBlockDesc"
                    ),
                    type: "switch",
                  },
                  model: {
                    value: _vm.imageProcessingBlock,
                    callback: function ($$v) {
                      _vm.imageProcessingBlock = $$v
                    },
                    expression: "imageProcessingBlock",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: _vm.$t(
                      "chatbotv2.imageProcessingSettings.processWithAI"
                    ),
                    icon: "ChatAiIcon",
                    description: _vm.$t(
                      "chatbotv2.imageProcessingSettings.processWithAIDesc"
                    ),
                    type: "switch",
                  },
                  model: {
                    value: _vm.imageProcessingAI,
                    callback: function ($$v) {
                      _vm.imageProcessingAI = $$v
                    },
                    expression: "imageProcessingAI",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.imageProcessingBlock && _vm.story.ai
        ? _c("div", { staticClass: "block-processing-settings" }, [
            _c(
              "div",
              { staticClass: "block-selection" },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("chatbotv2.imageProcessingSettings.fallbackBlock")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "chatbotv2.imageProcessingSettings.fallbackBlockDesc"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("BlockPicker", {
                  attrs: {
                    "flatted-diagram": _vm.flattedDiagram,
                    placeholder: _vm.$t(
                      "chatbotv2.imageProcessingSettings.fallbackBlockPlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.imageFallbackBlockId,
                    callback: function ($$v) {
                      _vm.imageFallbackBlockId = $$v
                    },
                    expression: "imageFallbackBlockId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block-selection" },
              [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "chatbotv2.imageProcessingSettings.directJumpBlock"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "chatbotv2.imageProcessingSettings.directJumpBlockDesc"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("BlockPicker", {
                  attrs: {
                    "flatted-diagram": _vm.flattedDiagram,
                    placeholder: _vm.$t(
                      "chatbotv2.imageProcessingSettings.directJumpBlockPlaceholder"
                    ),
                  },
                  model: {
                    value: _vm.imageDirectJumpBlockId,
                    callback: function ($$v) {
                      _vm.imageDirectJumpBlockId = $$v
                    },
                    expression: "imageDirectJumpBlockId",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.imageProcessingAI && _vm.story.ai
        ? _c("div", { staticClass: "ai-processing-settings" }, [
            _c("div", { staticClass: "ai-mode" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$t("chatbotv2.imageProcessingSettings.aiProcessingMode")
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "mode-items" },
                [
                  _vm.story.ai
                    ? _c("FeatureItem", {
                        attrs: {
                          title: _vm.$t(
                            "chatbotv2.imageProcessingSettings.processIndividual"
                          ),
                          icon: "ChatAiIcon",
                          description: _vm.$t(
                            "chatbotv2.imageProcessingSettings.processIndividualDesc"
                          ),
                          type: "switch",
                        },
                        model: {
                          value: _vm.aiProcessingIndividual,
                          callback: function ($$v) {
                            _vm.aiProcessingIndividual = $$v
                          },
                          expression: "aiProcessingIndividual",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.story.ai
                    ? _c("FeatureItem", {
                        attrs: {
                          title: _vm.$t(
                            "chatbotv2.imageProcessingSettings.processParallel"
                          ),
                          icon: "ChatAiIcon",
                          description: _vm.$t(
                            "chatbotv2.imageProcessingSettings.processParallelDesc"
                          ),
                          type: "switch",
                        },
                        model: {
                          value: _vm.aiProcessingParallel,
                          callback: function ($$v) {
                            _vm.aiProcessingParallel = $$v
                          },
                          expression: "aiProcessingParallel",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.aiProcessingParallel
              ? _c(
                  "div",
                  { staticClass: "buffer-time-setting" },
                  [
                    _vm.story.ai
                      ? _c("FeatureItem", {
                          attrs: {
                            title: _vm.$t(
                              "chatbotv2.imageProcessingSettings.bufferTime"
                            ),
                            icon: "ChatAiIcon",
                            description: _vm.$t(
                              "chatbotv2.imageProcessingSettings.bufferTimeDesc"
                            ),
                            type: "number",
                            min: 5,
                            max: 120,
                            step: 5,
                            "number-format": "integer",
                          },
                          on: {
                            blur: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                            increase: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                            decrease: function ($event) {
                              return _vm.changeImageBufferTime(
                                _vm.imageBufferTime
                              )
                            },
                          },
                          model: {
                            value: _vm.imageBufferTime,
                            callback: function ($$v) {
                              _vm.imageBufferTime = $$v
                            },
                            expression: "imageBufferTime",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-btn" },
        [
          _c(
            "SupsisButton",
            {
              attrs: { ghost: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.saveSettings } },
            [_vm._v(_vm._s(_vm.$t("common.save")))]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }